import store from '../store';
import db from './db';

export function moduleSlugs() {
    const storeSlugs = store.state.auth.platformModuleSlugs;
    const subscriptionSlugs = store.state.auth.platformSubscription?.module_slugs
        ?? db.platformSubscription?.module_slugs;

    if (Array.isArray(storeSlugs) && storeSlugs.length > 0) {
        return storeSlugs;
    }

    if (Array.isArray(subscriptionSlugs) && subscriptionSlugs.length > 0) {
        return subscriptionSlugs;
    }

    if (Array.isArray(storeSlugs)) {
        return storeSlugs;
    }

    return Array.isArray(subscriptionSlugs) ? subscriptionSlugs : [];
}

export function featureSlugs() {
    const storeSlugs = store.state.auth.platformFeatureSlugs;
    const subscriptionSlugs = store.state.auth.platformSubscription?.feature_slugs
        ?? db.platformSubscription?.feature_slugs;

    if (Array.isArray(storeSlugs) && storeSlugs.length > 0) {
        return storeSlugs;
    }

    if (Array.isArray(subscriptionSlugs) && subscriptionSlugs.length > 0) {
        return subscriptionSlugs;
    }

    if (Array.isArray(storeSlugs)) {
        return storeSlugs;
    }

    return Array.isArray(subscriptionSlugs) ? subscriptionSlugs : [];
}
